// extracted by mini-css-extract-plugin
export default {"backdrop":"PhotoZoom_backdrop__ktmsf","imageContainer":"PhotoZoom_imageContainer__5JJLk","image":"PhotoZoom_image__OAuHa"};